export enum TransactionStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  ACCEPTED = 'ACCEPTED',
  DELIVERED = 'DELIVERED', 
  CANCELLED = 'CANCELLED',
  ISSUED = 'ISSUED',
  UNDER_REVIEW = 'UNDER_REVIEW',
}